import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { AuthContext } from "../../context/AuthContext";
import Loading from "../../components/Loading/Loading";
import AppNavbar from "../../components/Navbars/AppNavbar";
import { SContainer, SParagraph, STitle } from "../../components/BasicComponents";

const AccountConfirmedPage = (props) => {
  const { t } = useTranslation("", { keyPrefix: "auth.account_confirmed" });

  const { confirmAccount, loading, error } = useContext(AuthContext);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (props.match.path === "/confirm/:confirmationCode") {
      const confirmationCode = props.match.params.confirmationCode;

      confirmAccount(confirmationCode).then((user) => {
        if (user) {
          setUser(user);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <SContainer dark="true" fluid fill="true" className="d-flex flex-column">
          <Row>
            <AppNavbar dark="true" />
          </Row>
          <Container className="m-auto">
            <Col xl={6} lg={6} md={10} sm={10} className="d-flex flex-column flex-grow-1 justify-content-center">
              {user && (
                <>
                  <h3>
                    <strong>{t("title")}</strong>
                    <p>{t("subtitle", { firstName: user.firstName, lastName: user.lastName })}</p>
                    <p>{t("description1")}</p>
                    <p>{t("description2")}</p>
                  </h3>
                  <Link to={"/"}>{t("login")}</Link>
                </>
              )}
              {error && (
                <>
                  <STitle className="fs-1 fw-bolder mb-4 p-2 text-uppercase">{t("error_title")}</STitle>
                  <SParagraph className="w-100 mt-1 mb-0 fs-4">{t("error")}</SParagraph>
                </>
              )}
            </Col>
          </Container>
        </SContainer>
      )}
    </>
  );
};

export default AccountConfirmedPage;
